export default __webpack_public_path__ + "static/media/misc008.b602278b.jpeg";